export default __webpack_public_path__ + "static/media/extra_cardsets_page.5ab1fc25.png";